/*
*   File : notification.js
*   Author : https://evoqins.com
*   Description : Notification listing page 
*   Integrations : NA
*   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';

//Style
import style from "../../Styles/Component/notification.module.scss";
import Colors from "../../Styles/color.scss";

//Custom component
import { useLocation, useNavigate } from 'react-router-dom';
import { CustomTab, EmptyScreen } from '../../Component/Others';
import { Icon } from '../../Component/Icon';
import { _scrollToTop } from '../../Helper';

// Assets
import EmptyNotification from '../../Assets/Images/EmptyScreen/empty-notification.webp';


// Custom data
const TAB_DATA = [
    {
        id: 1,
        label: "Transactional",
    },
    {
        id: 2,
        label: "Others"
    },
];

const NOTIFICATIONS = [
    {
        title: "New Security Feature Added",
        des: "We've enhanced your account security with two-factor authentication.",
        sent_time: "May 27 2024, 10:30 AM",
        is_read: false,
        icon: require("../../Assets/Images/Notification/security.svg").default,
    },
    {
        title: "New Investment Basket Released",
        des: "Curated by NextGen Wealth Advisors, this basket focuses on high-growth stocks. Check it out now!",
        sent_time: "",
        is_read: false,
        icon: "May 27 2024, 10:30 AM",
        icon: require("../../Assets/Images/Notification/basket.svg").default,
    },
    {
        title: "Portfolio Performance Update",
        des: "Your portfolio has increased by 5% in the last month. Lorem ipsum dolor sit amet consectetur. Auctor turpis elementum varius at augue nisi arcu pharetra. Integer id eget at turpis urna morbi nunc. This basket focuses on high-growth stocks. Check it out now!",
        sent_time: "May 11 2024, 07:30 AM",
        is_read: true,
        icon: require("../../Assets/Images/Notification/portfolio.svg").default,
    },
    {
        title: "New Investment Basket Released",
        des: "Curated by NextGen Wealth Advisors, this basket focuses on high-growth stocks. Check it out now!",
        sent_time: "",
        is_read: true,
        icon: "May 17 2024, 10:30 AM",
        icon: require("../../Assets/Images/Notification/basket.svg").default,
    },
];

const Notifications = () => {

    const navigate = useNavigate();
    const { state } = useLocation();

    const [tabIndex, setTabIndex] = useState(0);

    useEffect(() => {
        // Scroll the page to top
        _scrollToTop();
    }, [tabIndex]);

    useEffect(() => {
        if (state !== null) {
            setTabIndex(state);
        } else {
            setTabIndex(1);
        }
    }, [state]);

    // handle tab change
    const _handleTabChange = (id) => {
        navigate("/notifications", {
            state: id
        });
    };

    return (
        <section className={`${style.e_notification_wrapper} mb-5 e-bg-white border-radius-16 min-vh-100`}>
            <div className={`${style.e_top_section} border-radius-16 px-4 pt-4 overflow-hidden`}>
                <h4 className='e-font-16-res mb-0 e-primary-font-clash-display e-text-white e-font-20 e-font-weight-500 line-height-24px'>
                    Notifications (4)
                </h4>
                <div className='d-flex align-items-start justify-content-between padding-36px-top e-padding-16px-top-res'>
                    {/* Custom tab */}
                    <div className='d-flex gap-32px gap-24px-res'>
                        {TAB_DATA.map((tab, key) => (
                            <div key={key}>
                                <CustomTab tabIndex={tabIndex}
                                    className="e-font-14-res"
                                    data={tab}
                                    handleClick={_handleTabChange} />
                            </div>
                        ))}
                    </div>

                    {/* Clear btn */}
                    <div className='d-flex gap-1 align-items-center cursor-pointer'>
                        <span className='e-font-12-res e-text-white e-alt-font-lato e-font-14 e-font-weight-400 line-height-20px'>
                            Clear all
                        </span>
                        <Icon icon="clear-icon"
                            size="16px"
                            color={Colors.white}
                            className="d-flex" />
                    </div>
                </div>
            </div>

            {/* Notification data */}
            {
                !true ?
                    <EmptyScreen
                        type={1}
                        emptyScreenImage={EmptyNotification}
                        description="You have no new notifications at this time. Check back later for updates or review your settings to ensure you receive timely alerts." />
                    :

                    <div className='p-4 d-flex flex-column gap-3'>
                        {
                            NOTIFICATIONS.map((item, key) => (
                                <div key={key}
                                    className='d-flex gap-12px e-border-bottom-1px-anti-flash-white pb-3'>
                                    <div className='position-relative'>
                                        <img src={item.icon}
                                            className='w-24px-res'
                                            draggable={false}
                                            alt='notification' />
                                        {
                                            item.is_read == false &&
                                            <img src={require("../../Assets/Images/Notification/active-badge.svg").default}
                                                draggable={false}
                                                className='position-absolute top-0 end-0'
                                                alt='badge' />
                                        }
                                    </div>

                                    <div>
                                        <p className='mb-1 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-600 line-height-20px'>
                                            {item.title}
                                        </p>
                                        <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-12 e-font-weight-400 line-height-18px'>
                                            {item.des}
                                        </p>
                                        <p className='mb-1 e-text-philippine-gray e-alt-font-lato e-font-10 e-font-weight-400 line-height-18px'>
                                            {item.sent_time}
                                        </p>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
            }

        </section>
    )
}

export default Notifications;
